import { PersonalAccountSummaryData } from '@/modules/personalAccounts/PersonalAccountDetails/PersonalAccountDetails.types';

import { EntityDetailsData } from '../entityDetails.types';
import {
  getControllingPartyNameFromFragment,
  getOwnerNameFromFragment,
  getSharedSummaryProperties,
} from './accountsCardUtils';

export function getIndividualPersonalAccountSummaryProperties({
  entity,
}: EntityDetailsData): PersonalAccountSummaryData {
  if (entity.subtype.__typename !== 'IndividualPersonalAccount') {
    throw new Error('Invalid personal account type');
  }

  return {
    ...getSharedSummaryProperties(entity),
    beneficiaries: entity.subtype.beneficiaries || [],
    ownerNames: entity.subtype.owner
      ? [getOwnerNameFromFragment(entity.subtype.owner)]
      : [],
    ownerNamesShort: entity.subtype.owner
      ? getOwnerNameFromFragment(entity.subtype.owner)
      : '',
    effectiveDate: entity.subtype.effectiveDate || undefined,
    controllingPartyNames:
      entity.subtype.controllingParties?.map(
        getControllingPartyNameFromFragment
      ) ?? [],
    accountDetailsItems: [],
  };
}
